import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem, styled, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { get } from "lodash";
import { useState } from "react";
import { docTypeIcons } from "./documentTypes";

const StyledAttachmentCell = styled(TableCell)({
    fontSize: 14,
});

const StyledSortable = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
});

const DocumentPropertyManagementSnapshot = (props) => {
    const { viewDocument, savedDocuments } = props;

    const [docMenuKey, setDocMenuKey] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpenDocumentMenu = (docKey, anchorEl) => {
        setAnchorEl(anchorEl);
        setDocMenuKey(docKey);
    };

    const handlePreviewDocument = (url, docKey) => {
        setAnchorEl(null);
        viewDocument(url, docKey);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const columnDefs = [
        { display: "Name", prop: "mediaAssetName" },
        { display: "Document Type", prop: "documentType.name" },
        { display: "" },
    ];
    return (
        <Table>
            <TableHead>
                <TableRow>
                    {columnDefs.map((x, i) => (
                        <TableCell key={`doc-head-${i}`}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <StyledSortable>{x.display}</StyledSortable>
                            </div>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {Object.keys(savedDocuments).map((x, i) => {
                    const document = savedDocuments[x];
                    const docType = document?.documentType?.name ?? "";
                    return (
                        <TableRow key={`tr-doc-${i}`}>
                            <StyledAttachmentCell>
                                {get(
                                    docTypeIcons,
                                    get(document, "mediaAssetName", " ").split(".").pop().toLowerCase(),
                                    docTypeIcons["default"]
                                )()}
                                <span>{document["mediaAssetName"]}</span>
                            </StyledAttachmentCell>
                            <TableCell>
                                <div>{docType}</div>
                            </TableCell>
                            <TableCell>
                                <div>
                                    <IconButton
                                        disabled={false}
                                        aria-label="More"
                                        aria-owns={Boolean(document["anchorEl"]) ? `long-menu-${x}-${i}` : null}
                                        aria-haspopup="true"
                                        onClick={(e) => handleOpenDocumentMenu(document.mediaAssetKey, e.currentTarget)}
                                    >
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                        id="long-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={() => handleMenuClose()}
                                        slotProps={{
                                            paper: {
                                                style: {
                                                    width: 200,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem
                                            onClick={() =>
                                                handlePreviewDocument(get(document, "url", null), docMenuKey)
                                            }
                                        >
                                            Open in a new tab
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default DocumentPropertyManagementSnapshot;
